/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { Notification } from 'app/layout/common/notifications/notifications.types';
import { tap } from 'rxjs/operators';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';

@Injectable({
    providedIn: 'root'
})
export class NotificationsService
{
    private _notifications: ReplaySubject<Notification[]> = new ReplaySubject<Notification[]>(1);
    private _notification_count: ReplaySubject<{}> = new ReplaySubject<{}>(1);


    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        private _dataCollectorService: DataCollectorService,
        private _utilityService: UtilityService
        )
    {
    }

    getNotificationCountUrl(): string {
        return `${this._dataCollectorService.baseurl()}/user_notifications/count`;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for notifications
     */
    get notifications$(): Observable<Notification[]>
    {
        return this._notifications.asObservable();
    }

    get notificationCount$(): Observable<{}>
    {
        return this._notification_count.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all notifications
     */
    getAll(): void {
        this._httpClient.get<{}>(this.getNotificationCountUrl()).subscribe((count) => {
            this._notification_count.next(count);
        });
    }

    getAllNotificationCount(): void{
        this._dataCollectorService.getData(this.getNotificationCountUrl(),this._utilityService.constructParam({})).subscribe((response: any)=>{
            this._notification_count.next(response['count']);
        });
    }
}
